import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AsaxFrequencyViewModule} from 'asax-frequency-view';
import {AsaxHeaderModule} from 'asax-header';
import {AsaxResultTableModule} from 'asax-result-table';
import {AsaxSkyViewModule} from 'asax-sky-view';
import {AngularSplitModule} from 'angular-split';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AsaxPropertiesService} from "asax-properties";

function initializeApp(properties: AsaxPropertiesService) {
  return () => properties.init();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    AngularSplitModule,
    RouterModule.forRoot([]),
    AsaxFrequencyViewModule,
    AsaxHeaderModule,
    AsaxResultTableModule,
    AsaxSkyViewModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [AsaxPropertiesService]
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
